/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FilterStaffPins1FromJSON, FilterStaffPins1ToJSON } from './FilterStaffPins1';
import { PageInfoFromJSON, PageInfoToJSON } from './PageInfo';
export function GetStaffListsResponseDataFromJSON(json) {
    return GetStaffListsResponseDataFromJSONTyped(json, false);
}
export function GetStaffListsResponseDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        staffLists: !exists(json, 'staff_lists')
            ? undefined
            : json['staff_lists'].map(FilterStaffPins1FromJSON),
        pageInfo: !exists(json, 'page_info') ? undefined : PageInfoFromJSON(json['page_info'])
    };
}
export function GetStaffListsResponseDataToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        staff_lists: value.staffLists === undefined ? undefined : value.staffLists.map(FilterStaffPins1ToJSON),
        page_info: PageInfoToJSON(value.pageInfo)
    };
}
